import {NavigationTabsModuleEntityViewModel} from "./navigation-tabs-module.entity.view-model";
import {override} from 'mobx';
import {NAVIGATION_TABS} from "../../navigation-tabs-module.consts";
import {NavigationTabsModuleTabModel} from "../tabs/navigation-tabs-module.tab-model";
import {NavigationTabsModuleTerms} from "../../navigation-tabs-module.terms";
import {MatchesFilterTabModel} from "../tabs/matches-filter/matches-filter.tab-model";
import {NewMatchesFilterRecentTabModel} from "../tabs/new-matches-filter/new-matches-filter.recent.tab-model";
import {NewMatchesFilterFixturesTabModel} from "../tabs/new-matches-filter/new-matches-filter.fixtures.tab-model";
import {NewMatchesFilterResultsTabModel} from "../tabs/new-matches-filter/new-matches-filter.results.tab-model";
import {CompetitionMatchesPageLinkModel} from "../../../../containers/competition-container/pages/matches-page/models/competition-matches-page.link-model";

export class NavigationTabsModuleMatchesCompetitionViewModel extends NavigationTabsModuleEntityViewModel {
  terms: NavigationTabsModuleTerms;

  @override get tabs() {
    const overviewTab: MatchesFilterTabModel = new NewMatchesFilterRecentTabModel(NAVIGATION_TABS.TAB.INDEX.MATCHES.recent, this.terms.WEB_DROPDOWN_SCORES_OVERVIEW, this.entity, this.currentLinkModel, CompetitionMatchesPageLinkModel, this.isWidget);
    const fixturesTab: MatchesFilterTabModel = new NewMatchesFilterFixturesTabModel(NAVIGATION_TABS.TAB.INDEX.MATCHES.fixtures, this.terms.WEB_DROPDOWN_FIXTURES, this.entity, this.currentLinkModel, CompetitionMatchesPageLinkModel, this.isWidget);
    const results: MatchesFilterTabModel = new NewMatchesFilterResultsTabModel(NAVIGATION_TABS.TAB.INDEX.MATCHES.results, this.terms.WEB_DROPDOWN_RESULTS, this.entity, this.currentLinkModel, CompetitionMatchesPageLinkModel, this.isWidget);


    const tabs: Array<NavigationTabsModuleTabModel> = [overviewTab, fixturesTab, results];
    const filteredTabs: Array<NavigationTabsModuleTabModel> = tabs.filter(tab => tab.isVisible);

    return filteredTabs;
  }
}
